/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".popup[_ngcontent-%COMP%]{background-color:#fff;border-radius:3px;height:251px;color:#000;position:absolute!important;top:59px;z-index:10}.hide[_ngcontent-%COMP%]{display:None}"];
export { styles as styles };
